import { makeStyles } from '@soil-capital/ui-kit/style';

export const useFieldSelectionListItemStyle = makeStyles()(() => ({
    noPadding: {
        padding: 0,
    },
}));
